import { useQuery } from '@tanstack/react-query';
import { shopsService } from '../services/shops.service';
import type { ShopFilters } from '../types/shops.types';

export function useShops(filters?: ShopFilters) {
  return useQuery({
    queryKey: ['shops', filters],
    queryFn: () => shopsService.getShops(filters),
  });
}
